export default __webpack_public_path__ + "static/media/progress-bar.8e9ec2ee.svg";